import { CLIENT_SET_DATA } from '../actions';

const INIT_STATE = {
    id: null,
    numero_identificacion: null,
    nombres: '',
    conyuge_id: null,
    primer_nombre: '',
    primer_apellido: '',
    tmpTipoCodeudor: null,
    ciudad: null,
    barrio: null,
    direccion: null,
    celular: null,
    tipo_identificacion: null,
};

const rootReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLIENT_SET_DATA:
            return { ...state, ...action.payload };
        default:
            return { ...state };
    }
};

export default rootReducer;
